import { render, staticRenderFns } from "./studentSystemInfo.vue?vue&type=template&id=24353e49&"
import script from "./studentSystemInfo.vue?vue&type=script&lang=ts&"
export * from "./studentSystemInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports